import React, { useState, useEffect } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import {
  PlayIcon,
  PauseIcon,
  CreditCardIcon,
  CheckCircleIcon,
  XCircleIcon,
  ClockIcon,
  BoltIcon,
  ArrowPathIcon
} from '@heroicons/react/24/outline';
import api from '../services/api';
import socket from '../services/socket';
import toast from 'react-hot-toast';

function AmazonCardsPanel() {
  const [intervalSeconds, setIntervalSeconds] = useState(30);
  const [autoRunning, setAutoRunning] = useState(false);
  const queryClient = useQueryClient();

  // ================== SOCKET REAL TIME ==================
useEffect(() => {
  const token = localStorage.getItem("token");
  if (!token) return;

  api.get("/auth/profile")
    .then((response) => {
      const user = response.data.user || response.data;
      if (!user?._id) return;

      const userId = user._id;

      console.log("👤 Enviando join-user:", userId);

      socket.emit("join-user", userId);

      socket.on("amazon-real-attempt", (data) => {
        console.log("🔥 Evento recibido:", data);
        queryClient.invalidateQueries("amazon-cards-status");
      });
    })
    .catch((err) => {
      console.log("❌ Error obteniendo usuario:", err.message);
    });

  return () => {
    socket.off("amazon-real-attempt");
  };
}, []);

  const { data: statusData, isLoading, refetch } = useQuery('amazon-cards-status', async () => {
    const response = await api.get('/amazon-cards/status');
    return response.data;
  });

  const { data: cookiesData } = useQuery('amazon-cards-cookies', async () => {
    const response = await api.get('/amazon-cards/cookies');
    return response.data;
  });

  const { data: cardsData } = useQuery('amazon-cards-cards', async () => {
    const response = await api.get('/amazon-cards/cards');
    return response.data;
  });

  // Tarea simulada original
  const startMutation = useMutation(() => api.post('/amazon-cards/start'), {
    onSuccess: () => {
      queryClient.invalidateQueries('amazon-cards-status');
      toast.success('✅ Tarea iniciada');
      refetch();
    },
    onError: () => toast.error('❌ Error al iniciar')
  });

  const stopMutation = useMutation(() => api.post('/amazon-cards/stop'), {
    onSuccess: () => {
      queryClient.invalidateQueries('amazon-cards-status');
      toast.success('⏸️ Tarea detenida');
      refetch();
    },
    onError: () => toast.error('❌ Error al detener')
  });

  // ============ NUEVAS FUNCIONES REALES ============
  
  // Iniciar automático REAL
  const startRealAutoMutation = useMutation(
    (interval) => api.post('/real-amazon-auto/start', { intervalSeconds: interval }),
    {
      onSuccess: (data) => {
        toast.success(data.data.message);
        setAutoRunning(true);
        refetch();
      },
      onError: () => toast.error('❌ Error al iniciar proceso real')
    }
  );

  // Detener automático REAL
  const stopRealAutoMutation = useMutation(
    () => api.post('/real-amazon-auto/stop'),
    {
      onSuccess: (data) => {
        toast.success(data.data.message);
        setAutoRunning(false);
        refetch();
      },
      onError: () => toast.error('❌ Error al detener proceso real')
    }
  );

  // Agregar tarjeta manualmente a Amazon REAL
  const addCardManualMutation = useMutation(
    ({ cookieId, cardId }) => api.post('/real-amazon-auto/add-manual', { cookieId, cardId }),
    {
      onSuccess: (data) => {
        if (data.data.success) {
          toast.success(`✅ ${data.data.message}`);
        } else {
          toast.error(`❌ ${data.data.message}`);
        }
        queryClient.invalidateQueries('amazon-cards-status');
        refetch();
      },
      onError: (error) => {
        toast.error(error.response?.data?.message || '❌ Error al agregar tarjeta');
      }
    }
  );

  const status = statusData?.status;
  const cookies = cookiesData?.cookies || [];
  const cards = cardsData?.cards || [];
  const isRunning = status?.enabled || false;

  // Verificar si hay cookies de Amazon
  const hasAmazonCookies = cookies.length > 0;
  const amazonCookies = cookies;

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-cyan-500"></div>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '1rem', paddingBottom: '6rem' }}>
      {/* Header */}
      <div style={{ marginBottom: '1.5rem' }}>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#ffffff' }}>💳 Cards</h1>
        <p style={{ color: '#ff9900' }}>add it</p>
      </div>

      {/* Stats */}
      <div style={{ background: '#111111', borderRadius: '1rem', padding: '1rem', marginBottom: '1.5rem', border: '1px solid #222222' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
          <div>
            <span style={{ color: '#9ca3af' }}>🍪 Cookies:</span>
            <span style={{ color: '#ff9900', fontWeight: 'bold', marginLeft: '0.5rem' }}>{cookies.length}</span>
            <span style={{ color: '#9ca3af', marginLeft: '1rem' }}>💳 Tarjetas:</span>
            <span style={{ color: '#ff9900', fontWeight: 'bold', marginLeft: '0.5rem' }}>{cards.length}</span>
          </div>
          <div>
            {isRunning ? (
              <button onClick={() => stopMutation.mutate()} style={{ padding: '0.75rem 1.5rem', background: '#ff0033', border: 'none', borderRadius: '0.5rem', color: '#ffffff', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <PauseIcon style={{ width: '1.25rem', height: '1.25rem' }} /> prueba process
              </button>
            ) : (
              <button onClick={() => startMutation.mutate()} disabled={cookies.length === 0 || cards.length === 0} style={{ padding: '0.75rem 1.5rem', background: cookies.length === 0 || cards.length === 0 ? '#333333' : 'linear-gradient(135deg, #ff9900, #ff6600)', border: 'none', borderRadius: '0.5rem', color: '#000000', fontWeight: 'bold', cursor: cookies.length === 0 || cards.length === 0 ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: '0.5rem', opacity: cookies.length === 0 || cards.length === 0 ? 0.5 : 1 }}>
                <PlayIcon style={{ width: '1.25rem', height: '1.25rem' }} /> prueba process
              </button>
            )}
          </div>
        </div>
        {status && (
          <div style={{ marginTop: '0.75rem', fontSize: '0.875rem', color: '#9ca3af' }}>
            Intentos: {status.stats?.totalAttempts || 0} | ✅ Éxitos: {status.stats?.successful || 0} | ❌ Fallos: {status.stats?.failed || 0} | 💳 Agregadas: {status.stats?.cardsAdded || 0}
          </div>
        )}
      </div>

      {/* 🤖 AGREGADO AUTOMÁTICO REAL */}
      <div style={{ background: '#111111', borderRadius: '1rem', padding: '1rem', marginBottom: '1.5rem', border: '1px solid #ff9900' }}>
        <h3 style={{ color: '#ff9900', marginBottom: '1rem' }}>🤖 Agregado Automático</h3>
        <p style={{ color: '#9ca3af', marginBottom: '1rem' }}>
          TBL
        </p>
        
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={async () => {
              if (cookies.length === 0) {
                toast.error('No hay cookies de Amazon disponibles');
                return;
              }
              toast.loading('Iniciando proceso ...', { id: 'auto-start' });
              try {
                await startRealAutoMutation.mutateAsync(60);
                toast.success('Proceso  iniciado (cada 60 segundos)', { id: 'auto-start' });
              } catch (error) {
                toast.error('Error al iniciar', { id: 'auto-start' });
              }
            }}
            disabled={autoRunning}
            style={{ padding: '0.5rem 1rem', background: autoRunning ? '#666' : '#ff9900', border: 'none', borderRadius: '0.5rem', color: '#000000', fontWeight: 'bold', cursor: autoRunning ? 'not-allowed' : 'pointer' }}
          >
            ▶️ Iniciar  (cada 1 min)
          </button>
          
          <button
            onClick={async () => {
              toast.loading('Deteniendo proceso...', { id: 'auto-stop' });
              try {
                await stopRealAutoMutation.mutateAsync();
                toast.success('Proceso  detenido', { id: 'auto-stop' });
              } catch (error) {
                toast.error('Error al detener', { id: 'auto-stop' });
              }
            }}
            disabled={!autoRunning}
            style={{ padding: '0.5rem 1rem', background: !autoRunning ? '#666' : '#ff0033', border: 'none', borderRadius: '0.5rem', color: '#ffffff', fontWeight: 'bold', cursor: !autoRunning ? 'not-allowed' : 'pointer' }}
          >
            ⏹️ Detener Automático
          </button>
        </div>
      </div>

      {/* 📋 LISTA DE TARJETAS CON BOTÓN MANUAL */}
      <div style={{ marginBottom: '1.5rem' }}>
        <h3 style={{ color: '#ffffff', marginBottom: '1rem' }}>💳 Tus Tarjetas</h3>
        <div style={{ background: '#111111', borderRadius: '1rem', border: '1px solid #222222', overflow: 'hidden' }}>
          {cards.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '2rem', color: '#9ca3af' }}>
              <CreditCardIcon style={{ width: '2rem', height: '2rem', margin: '0 auto 0.5rem', opacity: 0.5 }} />
              <p>No hay tarjetas guardadas</p>
              <p style={{ fontSize: '0.75rem' }}>Agrega tarjetas en la sección "Tarjetas"</p>
            </div>
          ) : (
            <ul style={{ listStyle: 'none' }}>
              {cards.map((card) => (
                <li key={card.id} style={{ padding: '1rem', borderBottom: '1px solid #222222' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
                    <div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <CreditCardIcon style={{ width: '1.25rem', height: '1.25rem', color: '#ff9900' }} />
                        <span style={{ fontWeight: 'bold', color: '#ffffff' }}>{card.brand.toUpperCase()}</span>
                        <span style={{ fontFamily: 'monospace', color: '#00ffff' }}>•••• {card.lastFour}</span>
                      </div>
                      <div style={{ fontSize: '0.7rem', color: '#9ca3af', marginTop: '0.25rem' }}>
                        Expira: {card.expiryMonth}/{card.expiryYear} · {card.cardholderName}
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                      {/* 🛒 BOTÓN AGREGAR A AMAZON MANUAL */}
                      <button
                        onClick={async () => {
                          if (!hasAmazonCookies) {
                            toast.error('No hay cookies de Amazon. Agrega una cookie primero.');
                            return;
                          }
                          const selectedCookie = amazonCookies[0];
                          toast.loading(`Agregando tarjeta ${card.brand} •••• ${card.lastFour} a Amazon...`, { id: `add-${card.id}` });
                          try {
                            await addCardManualMutation.mutateAsync({
                              cookieId: selectedCookie.id,
                              cardId: card.id
                            });
                          } catch (error) {
                            // Error ya manejado en mutation
                          }
                        }}
                        style={{
                          padding: '0.25rem 0.75rem',
                          background: '#ff9900',
                          border: 'none',
                          borderRadius: '0.5rem',
                          color: '#000000',
                          fontSize: '0.75rem',
                          fontWeight: 'bold',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.25rem'
                        }}
                      >
                        🛒 Agregar 
                      </button>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {/* Estado en vivo */}
      {isRunning && status && (
        <div style={{ background: '#111111', borderRadius: '1rem', padding: '1rem', marginBottom: '1.5rem', border: '1px solid #ff9900' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
            <BoltIcon style={{ width: '1.25rem', height: '1.25rem', color: '#ff9900' }} />
            <span style={{ color: '#ff9900', fontWeight: 'bold' }}>Simulación en curso...</span>
          </div>
          {status.nextRunAt && (
            <div style={{ fontSize: '0.75rem', color: '#9ca3af' }}>
              ⏰ Próximo intento: {new Date(status.nextRunAt).toLocaleTimeString()}
            </div>
          )}
        </div>
      )}

      {/* Historial */}
      <div style={{ background: '#111111', borderRadius: '1rem', border: '1px solid #222222', overflow: 'hidden' }}>
        <div style={{ padding: '1rem', borderBottom: '1px solid #222222', background: '#1a1a1a' }}>
          <h3 style={{ color: '#ff9900', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <ClockIcon style={{ width: '1.25rem', height: '1.25rem' }} />
            Historial de Intentos
          </h3>
        </div>
        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
          {!status?.recentAttempts?.length ? (
            <div style={{ textAlign: 'center', padding: '3rem', color: '#9ca3af' }}>
              <CreditCardIcon style={{ width: '3rem', height: '3rem', margin: '0 auto 1rem', opacity: 0.5 }} />
              <p>No hay actividad aún</p>
              <p style={{ fontSize: '0.875rem', marginTop: '0.5rem' }}>Inicia el proceso para ver resultados</p>
            </div>
          ) : (
            status.recentAttempts.map((attempt, index) => (
              <div key={index} style={{ padding: '0.75rem 1rem', borderBottom: '1px solid #222222', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <div>{attempt.status === 'success' ? <CheckCircleIcon style={{ width: '1.25rem', height: '1.25rem', color: '#ccff00' }} /> : <XCircleIcon style={{ width: '1.25rem', height: '1.25rem', color: '#ff0033' }} />}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.5rem' }}>
                    <span style={{ color: '#ffffff' }}>{attempt.cardBrand} •••• {attempt.cardLastFour}</span>
                    <span style={{ fontSize: '0.7rem', color: '#9ca3af' }}>{new Date(attempt.createdAt).toLocaleTimeString()}</span>
                  </div>
                  <div style={{ fontSize: '0.7rem', color: attempt.status === 'success' ? '#ccff00' : '#ff0033', marginTop: '0.25rem' }}>{attempt.message}</div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default AmazonCardsPanel;